function optionChange(e) {}

function quickView(e) {
    0 == $("#quick-view").length && ($("body").append('<div id="quick-view"></div>'), $("body").addClass("quick-view_popup"));
    var t = e;
    $("#quick-view").addClass(t), jQuery.getJSON("/products/" + t + ".js", function(e) {
        (t => {
            let i = `/products/${t}`;
            return fetch(i).then(e => e.text()).then(t => {
                let i = new DOMParser,
                    o = i.parseFromString(t, "text/html"),
                    r = o.documentElement.querySelector(".qu_product");
                var n = e.images,
                    s = $(n).length;
                $(n).each(function(e, t) {
                    if (e == s - 1) {
                        var i = '<img src="' + t + '">';
                        i = i.replace(".jpg", "_800x.jpg").replace(".png", "_800x.png"), $("#quick-view .quick_image").append(i), $("#quick-view .quick_image").slick({
                            lazyLoad: "ondemand",
                            dots: !1,
                            infinite: !1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            swipe: !1,
                            speed: 500,
                            adaptiveHeight: !0,
                            infinite: !0,
                            prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 256 256" xml:space="preserve"><g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" ><path d="M 65.75 90 c 0.896 0 1.792 -0.342 2.475 -1.025 c 1.367 -1.366 1.367 -3.583 0 -4.949 L 29.2 45 L 68.225 5.975 c 1.367 -1.367 1.367 -3.583 0 -4.95 c -1.367 -1.366 -3.583 -1.366 -4.95 0 l -41.5 41.5 c -1.367 1.366 -1.367 3.583 0 4.949 l 41.5 41.5 C 63.958 89.658 64.854 90 65.75 90 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /></g></svg></button>',
                            nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="icon icon-caret" viewBox="0 0 256 256" xml:space="preserve"><g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" ><path d="M 24.25 90 c -0.896 0 -1.792 -0.342 -2.475 -1.025 c -1.367 -1.366 -1.367 -3.583 0 -4.949 L 60.8 45 L 21.775 5.975 c -1.367 -1.367 -1.367 -3.583 0 -4.95 c 1.367 -1.366 3.583 -1.366 4.95 0 l 41.5 41.5 c 1.367 1.366 1.367 3.583 0 4.949 l -41.5 41.5 C 26.042 89.658 25.146 90 24.25 90 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /></g></svg></button>'
                        }).css("opacity", "1")
                    } else i = (i = '<img src="' + t + '">').replace(".jpg", "_800x.jpg").replace(".png", "_800x.png"), $("#quick-view .quick_image").append(i)
                  return false;
                }), $("#quick-view .new_product").append(r), $("#quick-view .shopify-payment-button").detach(), setTimeout(function() {
                    $(".breadcrumb").remove(), $("#quick-view modal-opener").remove()
                }, 100)
            })
        })(t)
    }), $.fancybox({
        href: "#quick-view",
        maxWidth: 1040,
        maxHeight: 650,
        overlay: {
            locked: !1
        },
        fitToView: !0,
        width: "100%",
        height: "100%",
        autoSize: !1,
        openSpeed: 200,
        closeSpeed: 200,
        closeClick: !1,
        changeFade: "fast",
        openEffect: "elastic",
        closeEffect: "elastic",
        afterShow: function() {
            $("#quick-view").hide().html(content).css("opacity", "1").fadeIn()
        },
        afterClose: function() {
            $("#quick-view").removeClass().empty(), $("body").removeClass("quick-view_popup")
        }
    })
}
$(document).ready(function() {
    $.getScript("//cdn.shopify.com/s/files/1/0644/7526/7316/t/2/assets/fancybox.js").done(function() {})
});